import { CUSTOM_EVENTS_NAMES } from '@/constant/events';

export const triggerReplaceHistoryStateEvent = (detail: ReplaceHistoryStateEventData) => {
  const event = new CustomEvent(CUSTOM_EVENTS_NAMES.historyReplaceState, { detail });
  return window.dispatchEvent(event);
};
